import { render, staticRenderFns } from "./DeviceShow.vue?vue&type=template&id=bafb69aa&"
import script from "./DeviceShow.vue?vue&type=script&lang=js&"
export * from "./DeviceShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports